<lib-active-filters></lib-active-filters>
<div class="panel-flex">
  <app-submissions-list-view
    [@toggle-main-panel]="isDetailOpen ? 'open' : 'closed'"
    [isDetailOpen]="isDetailOpen"
    [activeSubmission]="submission"
    [materialPageIndex]="materialPageIndex"
    (selectedSubmission)="selectSubmission($event)"
    (selectedManualSub)="onManualSubNavigation($event)"
    (pageChange)="onPageChange($event)"
    (sortChange)="onPageSort($event)"
    (searchChange)="onSearchChange($event)"
    [shouldClearSearch]="shouldClearSearch"
    >
  </app-submissions-list-view>
  @if (submission) {
    <app-submissions-detail-view
      [@toggle-detail-panel]="isDetailOpen ? 'open' : 'closed'"
      (close)="closeDetail()"
      (save)="updateView()"
      (delete)="resetView()"
      (unsavedChangesUpdate)="hasUnsavedChanges = $event"
      [submissionViewItem]="submission"
    ></app-submissions-detail-view>
  }
</div>

